import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from '../navbar/navbar.component';
import { ThemeToggleComponent } from '../theme-toggle/theme-toggle.component';
import { PageTitleService } from '../page-title.service';
import { ShellUser } from '../../models/shell-user.interface';
import { SidebarStateService } from './sidebar-state.service';
import { HttpLoadingService } from '../http-loading/http-loading.service';
import { TourOverlayComponent } from '../../overlays/tour/tour-overlay.component';
import { ToastOutletComponent } from '../../overlays/toast/toast-outlet.component';

@Component({
  selector: 'tc-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NavbarComponent,
    ThemeToggleComponent,
    TourOverlayComponent,
    ToastOutletComponent,
  ],
  providers: [SidebarStateService],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css',
})
export class LayoutComponent implements OnInit, OnDestroy {
  readonly pageTitle = inject(PageTitleService);
  readonly sidebar = inject(SidebarStateService);
  readonly httpLoading = inject(HttpLoadingService);

  @Input() user: ShellUser | null = null;
  @Input() logoUrl = '/images/logo.svg';
  /** Optional product name shown next to the logo (e.g. "Billing"). */
  @Input() brandLabel = '';
  @Input() showThemeToggle = true;
  @Input() showHttpLoading = true;
  @Input() showTourOverlay = true;
  @Input() showToastOutlet = true;

  @Output() logout = new EventEmitter<void>();

  ngOnInit(): void {
    this.sidebar.init();
  }

  ngOnDestroy(): void {
    this.sidebar.ngOnDestroy();
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.sidebar.onWindowResize();
  }
}
